export const GRAPHQL_VARIABLES = {
  record: {
    customerId: '5fc44c1f84ffd06759c1a1e3',
    status: 'draft',
    allowedPaymentTypes: ['card'],
    currency: 'AUD',
    total: 10000,
    paid: true,
    amountDue: 10000,
    amountPaid: 0,
    metadata: { ref: '123' }
  }
};

export const QUERY = `
  mutation invoicesCreateOne ($record: AutoFilledCreateOneinvoicesInput!) {
    invoicesCreateOne (record: $record) {
        recordId
        record {
            companyId
            status
            allowedPaymentTypes
            currency
            total
            paid
            amountDue
            amountPaid
            metadata
            bkInvoice
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
